import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LocationIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Location",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M16 2C10.1 2 5.32 6.78 5.32 12.68S16 30 16 30s10.68-11.39 10.68-17.32S21.9 2 16 2m0 15.59c-2.71 0-4.9-2.2-4.9-4.9s2.2-4.9 4.9-4.9 4.9 2.2 4.9 4.9-2.2 4.89-4.9 4.89Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M16.29 16.43c-3.15 0-5.71-2.56-5.71-5.71s2.56-5.71 5.71-5.71S22 7.57 22 10.72s-2.56 5.71-5.71 5.71m0-9.14c-1.89 0-3.43 1.54-3.43 3.43s1.54 3.43 3.43 3.43 3.43-1.54 3.43-3.43-1.54-3.43-3.43-3.43"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16.29 31.85c-.99 0-1.94-.43-2.6-1.19-2.46-2.84-8.83-11.86-8.83-19.37C4.86 4.98 9.98-.14 16.29-.14s11.43 5.13 11.43 11.43c0 7.51-6.38 16.53-8.83 19.37-.65.76-1.6 1.19-2.59 1.19Zm0-29.71c-5.04 0-9.14 4.1-9.14 9.14 0 6.05 5.08 14.17 8.28 17.87.45.52 1.28.52 1.73 0 3.2-3.7 8.28-11.82 8.28-17.87 0-5.04-4.1-9.14-9.14-9.14Z"
      })]
    })
  }));
};
LocationIcon.displayName = 'LocationIcon';